export const STARTER_PLAN = 'starter-plan';
export const GROWTH_PLAN = 'growth';
export const PRO_PLAN = 'pro';
export const ENTERPRISE_PLAN = 'enterprise';
export const TRIAL_DAYS = 7;

export const PLAN_LIMITS: Record<string, { price: number; limit: number; isLifetime: boolean; expectedRecovery: string; feePercentage: number; usageCap: number }> = {
  [STARTER_PLAN]: { limit: 10, isLifetime: true, price: 0, expectedRecovery: "$500 Total", feePercentage: 0.05, usageCap: 100 },
  [GROWTH_PLAN]: { limit: 100, isLifetime: false, price: 49, expectedRecovery: "$5,000 /mo", feePercentage: 0.03, usageCap: 5000 },
  [PRO_PLAN]: { limit: 1000, isLifetime: false, price: 199, expectedRecovery: "$50,000 /mo", feePercentage: 0.01, usageCap: 10000 },
  [ENTERPRISE_PLAN]: { limit: Infinity, isLifetime: false, price: 499, expectedRecovery: "Unlimited", feePercentage: 0.005, usageCap: 25000 },
};
